import clsx from "clsx";

function wrapImagesWithDiv(htmlString) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, "text/html");
  const imgElements = doc.querySelectorAll("img");

  imgElements.forEach((img) => {
    const div = doc.createElement("div");
    div.className = "imgParent";

    img.parentNode.insertBefore(div, img);
    div.appendChild(img);
  });

  // Serialize the modified document back to an HTML string
  return new XMLSerializer().serializeToString(doc);
}

export default function ArticlePreview({ tags, title, date, body, author }) {
  const textBody = wrapImagesWithDiv(body);
  
  return (
    <div className={articleContainer}>
      <div className="px-10 md:w-[600px]">
        <div className="text-4xl font-bold">{title}</div>
        <div className="my-4 flex w-full">
          {author && <div className="text-wrap italic">By {author}</div>}
          <div className="whitespace-nowrap text-black/40">
            {author && <span className="px-2">|</span>}
            {date}
          </div>
        </div>
        <div className="flex w-full mb-8">
          {tags.map((tag) => (
            <div className={clsx(tagStyle + "!bg-black/5")}>{tag}</div>
          ))}
        </div>
        <div
          className={htmlWrapper}
          dangerouslySetInnerHTML={{ __html: textBody }}
        ></div>
      </div>
    </div>
  );
}

const htmlWrapper = clsx(
  "article-body mb-20 flex h-full flex-col md:text-[16px] lg:mb-40"
);
const articleContainer = clsx(
  "flex flex-col items-center justify-center pt-10 md:mt-0 border-[1px] border-black/10 rounded-b-md"
);
const tagStyle = clsx(
  "mr-4 rounded-sm bg-white/20 px-4 py-2 text-xxs font-bold uppercase tracking-widest whitespace-nowrap "
);
